import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { AvailabilityMessageType } from "@insite/client-framework/Types/ApiModels";

export function hasEnoughInventory(state: ApplicationState, productContext: ProductContextModel) {
    const {
        product,
        productInfo: { inventory, unitOfMeasure },
    } = productContext;
    const { fulfillmentMethod } = getSession(state);
    const { productSettings } = getSettingsCollection(state);
    const allowBackOrder =
        fulfillmentMethod === FulfillmentMethod.PickUp
            ? productSettings.allowBackOrderForPickup
            : productSettings.allowBackOrderForDelivery;
    const inventoryAvailability = inventory?.inventoryAvailabilityDtos?.find(o => o.unitOfMeasure === unitOfMeasure);

    // xng-change
    if (inventoryAvailability?.availability?.messageType === AvailabilityMessageType.LowStock) {
        return product.isVariantParent || !product.trackInventory;
    }
    // xng-change-end

    return (
        allowBackOrder ||
        product.isVariantParent ||
        !product.trackInventory ||
        inventoryAvailability?.availability?.messageType !== AvailabilityMessageType.OutOfStock
    );
}
